import React from 'react';
import styles from './motivator.module.sass';
import { Text } from '../Text';

export const Motivator = ({ children, emoji, textcolor }) => (
  <div className={styles.border}>
    <div className={styles.emojiBlock}>{emoji}</div>
    <div>
      <Text variant="text-4" colorText={textcolor}>
        {children}
      </Text>
    </div>
  </div>
);
Motivator.defaultProps = {
  textcolor: 'orange',
};
